import { useState, useMemo, useRef, useEffect } from "react";

import {

    ClipboardList,

    ChevronDown,

    Search,

    FileText,

    ShieldPlus,

    Wallet

} from "lucide-react";

export default function VexaConceptSelector({

    value,

    options,

    onChange,

    placeholder = "Seleccionar concepto"

}) {

    const [open, setOpen] = useState(false);

    const [search, setSearch] = useState("");

    const containerRef = useRef(null);

    useEffect(() => {

        function handleClick(e) {

            if (

                containerRef.current &&

                !containerRef.current.contains(e.target)

            ) {

                setOpen(false);

            }

        }

        document.addEventListener(

            "mousedown",

            handleClick

        );

        return () =>

            document.removeEventListener(

                "mousedown",

                handleClick

            );

    }, []);

    const filtered = useMemo(() => {

        return options.filter(item => {

            const texto = `${

                item.descripcion ||

                item.folio ||

                ""

            } ${

                item.tipo ||

                ""

            }`

            .toLowerCase();

            return texto.includes(

                search.toLowerCase()

            );

        });

    }, [

        options,

        search

    ]);

    return (

        <div

            ref={containerRef}

            className="relative w-full"

        >

            <button

                type="button"

                onClick={() =>

                    setOpen(!open)

                }

                className="

                    w-full

                    flex

                    items-center

                    justify-between

                    rounded-xl

                    border

                    border-gray-300

                    bg-white

                    px-4

                    py-3

                    shadow-sm

                    hover:border-blue-400

                    transition-all

                "

            >

                <div className="flex items-center gap-3">

                    <ClipboardList

                        size={20}

                        className="text-blue-600"

                    />

                    <div className="flex flex-col items-start">

                        {

                            value ? (

                                <>

                                    <span className="font-medium text-gray-900">

                                        {value.motivo}

                                    </span>

                                    <span className="text-xs text-gray-500">

                                        Saldo pendiente $

                                        {Number(

                                            value.saldo || 0

                                        ).toLocaleString("es-MX")}

                                    </span>

                                </>

                            ) : (

                                <span className="text-gray-500">

                                    {placeholder}

                                </span>

                            )

                        }

                    </div>

                </div>

                <ChevronDown

                    size={18}

                    className={`transition-transform ${

                        open

                        ?

                        "rotate-180"

                        :

                        ""

                    }`}

                />

            </button>

            {open && (

                <div

                    className="

                        absolute

                        z-50

                        mt-2

                        w-full

                        rounded-2xl

                        border

                        bg-white

                        shadow-xl

                        overflow-hidden

                    "

                >

                    <div className="p-3 border-b">

                        <div className="relative">

                            <Search

                                size={16}

                                className="

                                    absolute

                                    left-3

                                    top-3

                                    text-gray-400

                                "

                            />

                            <input

                                value={search}

                                onChange={e =>

                                    setSearch(

                                        e.target.value

                                    )

                                }

                                placeholder="Buscar..."

                                className="

                                    w-full

                                    rounded-xl

                                    border

                                    pl-10

                                    pr-3

                                    py-2.5

                                "

                            />

                        </div>

                    </div>

                    <div

                        className="

                            max-h-72

                            overflow-y-auto

                        "

                    >

                        {

                            filtered.map(item => (

                                <button

                                    key={item.id}

                                    type="button"

                                    onClick={() => {

                                        onChange(item);

                                        setOpen(false);

                                    }}

                                    className="

                                        w-full

                                        text-left

                                        px-4

                                        py-4

                                        border-b

                                        last:border-0

                                        hover:bg-blue-50

                                        transition-all

                                        duration-200

                                    "

                                >

                                    <div className="flex items-center gap-4">

                                        {

                                            item.tipo === "planTratamiento"

                                                ?

                                                <FileText

                                                    size={20}

                                                    className="text-blue-600 flex-shrink-0"

                                                />

                                                :

                                                <ShieldPlus

                                                    size={20}

                                                    className="text-emerald-600 flex-shrink-0"

                                                />

                                        }

                                        <div className="flex-1">

                                            <div className="flex justify-between items-start">

                                                <div>

                                                    <div className="font-semibold text-gray-900">

                                                        {

                                                            item.tipo === "planTratamiento"

                                                                ? item.folio

                                                                : item.descripcion

                                                        }

                                                    </div>

                                                    <div className="text-xs text-gray-500 mt-1">

                                                        {

                                                            item.tipo === "planTratamiento"

                                                                ? "Plan de tratamiento"

                                                                : "Cita"

                                                        }

                                                    </div>

                                                </div>

                                                <div className="flex items-center gap-1 font-semibold text-blue-700">

                                                    <Wallet size={15} />

                                                    $

                                                    {

                                                        Number(

                                                            item.saldo || 0

                                                        ).toLocaleString("es-MX")

                                                    }

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </button>

                            ))

                        }

                    </div>

                </div>

            )}

        </div>

    );

}